import { Dropdown, Toggle } from "pepsico-ds";
import PropTypes from "prop-types";

const DistributionStrategySection = ({
  distributionStrategy,
  rolloverEnabled,
  onDistributionStrategyChange,
  onRolloverChange,
  disabled = false,
  configFields = {},
  distributionStrategies = [],
}) => {
  const defaultConfigFields = {
    distribution_strategy: {
      title: "Distribution Strategy",
      required: true,
    },
    rollover_enabled: {
      title: "Fallback Logic",
      description: "Enable fallback logic for reward allocation",
      required: true,
    },
  };

  const fields = { ...defaultConfigFields, ...configFields };

  return (
    <div className="form-row mb-3">
      <div className="form-col">
        <div className="form-field-wrapper">
          <label
            className={`form-field-label ${fields.distribution_strategy.required ? "required" : ""}`}
          >
            {fields.distribution_strategy.title}
          </label>
          <Dropdown
            childList={distributionStrategies.map((s) => ({
              id: s.key,
              displayText: s.label,
            }))}
            selection="single"
            selectedValue={
              distributionStrategy
                ? [
                    {
                      id: distributionStrategy,
                      displayText:
                        distributionStrategies.find(
                          (s) => s.key === distributionStrategy
                        )?.label || distributionStrategy,
                    },
                  ]
                : undefined
            }
            setSelectedValue={(value) => {
              const strategyValue = Array.isArray(value)
                ? value[0]?.id
                : value?.id || value;
              onDistributionStrategyChange(strategyValue);
            }}
            disabled={disabled}
            placeholder="Select strategy"
            data-testid="distribution-strategy-select"
          />
        </div>
      </div>
      <div className="form-col">
        <div className="form-field-wrapper">
          <label
            className={`form-field-label ${fields.rollover_enabled.required ? "required" : ""}`}
          >
            {fields.rollover_enabled.title}
          </label>
          <div className="toggle-field-container">
            <Toggle
              checked={rolloverEnabled}
              onUpdate={onRolloverChange}
              disabled={disabled}
              size="medium"
              data-testid="rollover-toggle"
            />
            <span className="toggle-description">
              {fields.rollover_enabled.description}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

DistributionStrategySection.propTypes = {
  distributionStrategy: PropTypes.string,
  rolloverEnabled: PropTypes.bool,
  onDistributionStrategyChange: PropTypes.func.isRequired,
  onRolloverChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  configFields: PropTypes.object,
  distributionStrategies: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
};

export default DistributionStrategySection;
